module.exports = __webpack_public_path__ + "img/tribe-common.38746eb6.svg";